<template>
  <div class="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
    <BaseToast
      v-for="toast in toasts"
      :key="toast.id"
      v-bind="toast"
      @close="removeToast(toast.id)"
    />
  </div>
</template>

<script>
import BaseToast from "./BaseToast.vue";

let id = 0;

export default {
  name: "ToastContainer",
  components: { BaseToast },
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    addToast(options) {
      this.toasts.push({
        id: id++,
        ...options,
      });
    },
    removeToast(toastId) {
      this.toasts = this.toasts.filter((t) => t.id !== toastId);
    },
  },
};
</script>
